import type { NDateLocale } from './enUS'
import { ru } from 'date-fns/locale'

const dateRuRU: NDateLocale = {
  name: 'ru-RU',
  locale: ru
}

export default dateRuRU
